export const AccidentCrossSellFormFields = {
  NUMBER_CO_INSURED: 'numberCoInsured',
  START_DATE: 'startDate',
  INTENT: 'intent',
} as const
